import { createContext } from 'react';

interface Cart {
  isOpen: boolean;
  cartProducts: any[];
}

export const CartContext = createContext<Cart>({
  isOpen: false,
  cartProducts: [],
});
